import { DITypes } from "@/core/@types/types";
import { F360UnitDate, type IF360Date } from "@/core/plugins/date/F360Date";
import { inject, injectable } from "inversify";
import "reflect-metadata";

@injectable()
export class PeriodoDocumentoDisponivel {
  @inject(DITypes.DATE)
  private readonly date!: IF360Date;

  private getCurrentYear(): number {
    return this.date.now().getFullYear();
  }

  getUltimoAnoDisponivel(dataLimite = `${this.getCurrentYear()}/02/20`): Date {
    const currentDate = this.date.now();

    const limiteEntregaDocumento = this.date.getNewDate(dataLimite);

    const isBeforeTwentyFeb = this.date.isBefore(
      currentDate,
      limiteEntregaDocumento
    );

    return isBeforeTwentyFeb
      ? this.date.subtract(this.date.now(), 1, F360UnitDate.Year)
      : this.date.now();
  }

  getUltimosAnosDisponiveis(
    anos = 4,
    ultimoAnoDisponivel = this.getUltimoAnoDisponivel()
  ) {
    const years: number[] = [];

    for (let index = 0; index <= anos; index++) {
      const year = this.date
        .subtract(ultimoAnoDisponivel, index, F360UnitDate.Year)
        .getFullYear();
      years.push(year);
    }

    return years;
  }
}
